package com.ervasstudio.tracoemovimento.pages.home.mobile

import androidx.compose.runtime.Composable
import com.ervasstudio.tracoemovimento.util.Res
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.browser.window
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px


@Composable
fun SeccaoPretaHomeDesktop() {
    Column(
        modifier = Modifier.fillMaxWidth().backgroundColor(Colors.Black),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center
    ) {
        Box(
            modifier = Modifier.fillMaxWidth().position(Position.Relative),
            contentAlignment = Alignment.Center
        ) {
            Row(
                modifier = Modifier.fillMaxSize().padding(right = 130.px),
                horizontalArrangement = Arrangement.End,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Image(src = Res.Image.bolasite, modifier = Modifier.width(100.percent))
            }

            Row(
                modifier = Modifier.fillMaxSize(),
                horizontalArrangement = Arrangement.Center,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Column(
                    modifier = Modifier.width(40.cssRem).padding(bottom = 24.px, top = 70.px),
                    horizontalAlignment = Alignment.End,
                    verticalArrangement = Arrangement.Bottom
                ) {
                    SpanText(
                        "Queres aprender os fundamentos da animação com as mesmas bases que a nossa turma recebeu no Traço e Movimento? \n" +
                                "Descarrega o nosso manual de animação, gratuito, e explora este universo.",
                        modifier = Modifier.display(DisplayStyle.Block).textAlign(TextAlign.Justify)
                            .fontSize(29.px).fontFamily("museomoderno").fontWeight(FontWeight.Light)
                            .margin(top = 20.px, bottom = 10.px).color(Colors.White)
                    )

                    Box(
                        modifier = Modifier.fillMaxWidth().position(Position.Relative).cursor(Cursor.Pointer)
                            .onClick {
                                window.open("https://apitracoemovimento.ervasstudio.com/wp-content/uploads/2026/07/Manual-da-Formacao-imp.pdf", "_blank")
                            },
                        contentAlignment = Alignment.Center
                    ) {
                        Image(
                            modifier = Modifier.fillMaxWidth().objectFit(ObjectFit.Fill),
                            src = Res.Image.bgstyle,
                        )
                        Column(
                            horizontalAlignment = Alignment.CenterHorizontally,
                            verticalArrangement = Arrangement.Center,
                            modifier = Modifier.fillMaxHeight().padding(bottom = 20.px)
                        ) {
                            SpanText(
                                modifier = Modifier.fontSize(60.px).fontFamily("museomodernoboldItalic")
                                    .fontWeight(FontWeight.Bold).lineHeight(1).color(Colors.Black),
                                text = "Descarregar"
                            )
                            SpanText(
                                modifier = Modifier.fontSize(32.px).fontFamily("museomodernoboldItalic")
                                    .fontWeight(FontWeight.Bold).lineHeight(1.5).textAlign(TextAlign.Start)
                                    .color(Colors.Black),
                                text = "Manual de animação"
                            )
                        }
                    }
                }
            }
        }
    }
}
